
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
const Item = ({ item }) => {
    return <li className={'list_item'}>
        {item.title}
    </li>;
};
const Problem = ({ t }) => {
    const problem = t('our_vision:problem', {}, { returnObjects: true });
    return (<section className={'problem'}>
            <div className="container">
                <div className="problem_wrapper">
                    <div className="problem_media">
                    </div>
                    <div className="problem_info">
                        <h2 className={'problem_info_title'}>{problem.title}</h2>
                        <p className={'problem_info_description'}>{problem.description}</p>
                        <div className="problem_info_line">
                            <div className="line_check">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <g clipPath="url(#clip0_487_235)">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M13.6371 1.19841C14.0628 1.55023 14.1228 2.18055 13.7709 2.60628L5.7309 12.3355L5.72848 12.3384C5.5456 12.558 5.31608 12.7341 5.05661 12.8538C4.79713 12.9736 4.51423 13.034 4.22848 13.0307C3.93805 13.0271 3.65131 12.9577 3.39152 12.8278C3.1326 12.6984 2.90626 12.5121 2.72937 12.283L0.210694 9.04474C-0.128376 8.6088 -0.049842 7.98052 0.386105 7.64145C0.822053 7.30238 1.45033 7.38092 1.7894 7.81686L4.25297 10.9843L12.2292 1.33225C12.581 0.906522 13.2114 0.846601 13.6371 1.19841Z" fill="#000034"/>
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_487_235">
                                            <rect width="14" height="14" fill="white"/>
                                        </clipPath>
                                    </defs>
                                </svg>
                            </div>
                            <div className="line_line"/>
                        </div>
                        <ul className={'problem_info_list'}>
                            {problem.solved_list.map(item => {
            return <Item key={item.key} item={item}/>;
        })}
                        </ul>
                    </div>
                </div>
            </div>
        </section>);
};
export default Problem;

    async function __Next_Translate__getStaticProps__196111dc735__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//about/vision/Problem/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196111dc735__ as getStaticProps }
  